export default __webpack_public_path__ + "static/vimium_chrome_plugin-802397839db5697485df17477c10d6c0.png";